import { css } from '@emotion/react'
import emotionStyled from '@emotion/styled'
import { Button } from '@material-ui/core'

export const ButtonBase = emotionStyled(Button)`
  font-weight: 700 !important;
  border-radius: 10px !important;
  box-shadow: none !important; /* default: tanpa shadow */

  ${({ size }) => {
    if (size === 'small')
      return css`
        padding: 0.25rem 0.5rem !important;
      `
    return css`
      padding: 0.5rem 1rem !important;
    `
  }}

  > span.MuiButton-label {
    display: flex;
    flex-flow: row no-wrap;
    gap: .5rem;
    > span {
      margin: 0;
    }
  }

  &:hover {
    cursor: pointer !important;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15) !important; /* shadow hanya saat hover */
  }

  &:disabled {
    cursor: not-allowed !important;
    box-shadow: none !important;
    background: rgba(241, 245, 249, 1) !important;
    border: 1px solid rgba(226, 232, 240, 1) !important;
    color: rgba(203, 213, 225, 1) !important;
  }
`

export const ButtonGhost = emotionStyled(ButtonBase)`
  background-color: rgba(255, 255, 255, 1) !important;
  color: rgba(49, 53, 59, 0.85) !important;
  border: none !important;
`
export const ButtonPrimary = emotionStyled(ButtonBase)`
  background-color: rgba(0, 104, 225, 1) !important;
  color: rgba(255, 255, 255, 1) !important;
  border: 1px solid rgba(0, 104, 225, 1) !important;
`
export const ButtonPrimaryOutlined = emotionStyled(ButtonBase)`
  background-color: rgba(255, 255, 255, 1) !important;
  color: rgba(0, 104, 225, 1) !important;
  border: 1px solid rgba(0, 104, 225, 1) !important;
`
export const ButtonSecondary = emotionStyled(ButtonBase)`
  background-color: rgba(255, 255, 255, 1) !important;
  color: rgba(49, 53, 59, 0.85) !important;
  border: 1px solid rgba(49, 53, 59, 0.85) !important;
`
export const ButtonSecondaryOutlined = emotionStyled(ButtonBase)`
  color: rgba(49, 53, 59, 0.85) !important;
  background-color: rgba(255, 255, 255, 1) !important;
  border: 1px solid rgba(49, 53, 59, 0.85) !important;
`
export const ButtonSuccess = emotionStyled(ButtonBase)`
  color: rgba(255, 255, 255, 1) !important;
  background-color: rgba(34, 197, 94, 1) !important;
  border: 1px solid rgba(34, 197, 94, 1) !important;
`
export const ButtonSuccessOutlined = emotionStyled(ButtonBase)`
  color: rgba(34, 197, 94, 1) !important;
  background-color: rgba(255, 255, 255, 1) !important;
  border: 1px solid rgba(34, 197, 94, 1) !important;
`
export const ButtonWarning = emotionStyled(ButtonBase)`
  color: rgba(255, 255, 255, 1) !important;
  background-color: rgba(249, 115, 22, 1) !important;
  border: 1px solid rgba(249, 115, 22, 1) !important;
`
export const ButtonWarningOutlined = emotionStyled(ButtonBase)`
  color: rgba(249, 115, 22, 1) !important;
  background-color: rgba(255, 255, 255, 1) !important;
  border: 1px solid rgba(249, 115, 22, 1) !important;
`
export const ButtonDanger = emotionStyled(ButtonBase)`
  color: rgba(255, 255, 255, 1) !important;
  background-color: rgba(244, 63, 94, 1) !important;
  border: 1px solid rgba(244, 63, 94, 1) !important;
`
export const ButtonDangerOutlined = emotionStyled(ButtonBase)`
  color: rgba(244, 63, 94, 1) !important;
  background-color: rgba(255, 255, 255, 1) !important;
  border: 1px solid rgba(244, 63, 94, 1) !important;
`
